var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import { useEffect } from 'react';
import { useState } from 'react';
import usePrevious from '../usePrevious/usePrevious';
import useCRUD from './useCRUD';
import operations from './operations';
const useCrudReadOperation = (featureEnum, operation, payload, error, success, dependencyProps, sortArgument, pageIndex) => {
    const [data, setData] = useState(null);
    const { get, list, count } = useCRUD(featureEnum);
    const prevDependencyProps = usePrevious(dependencyProps);
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            let fetchedData = null;
            switch (operation) {
                case operations.GET:
                    fetchedData = yield get(payload, error, success, sortArgument, pageIndex);
                    break;
                case operations.COUNT:
                    fetchedData = yield count(payload, error, success, sortArgument, pageIndex);
                    break;
                case operations.LIST:
                    fetchedData = yield list(payload, error, success, sortArgument, pageIndex);
                    break;
            }
            if (fetchedData)
                setData(fetchedData);
        });
        const validatedDependencies = dependencyProps === null || dependencyProps === void 0 ? void 0 : dependencyProps.reduce((el, acc) => (acc && el ? true : false), true);
        if (payload && (!data || !_.isEqual(dependencyProps, prevDependencyProps)) && validatedDependencies)
            fetchData();
    }, [payload, data, get, list, operation, dependencyProps, prevDependencyProps, sortArgument, pageIndex, error, success, count]);
    return data;
};
export default useCrudReadOperation;
